import { useEffect } from 'react';
import ReactGA from 'react-ga4';

export const useInit = (trackingId: string) => {
  useEffect(() => {
    ReactGA.initialize(trackingId, {
      testMode: process.env.REACT_APP_ENV === 'development',
    });
  }, [trackingId]);
};
